import { useState, useEffect } from 'react'
import { getDesgCotid } from "../../Fetch/GetDesgCotid";
import { useSearchParams, useNavigate } from "react-router";
import { Link } from 'react-router'
import Navbar from "../../Components/NavBar/Navbar";
import Tabla, { Cell, Row, Head, Body } from "../../Components/Tabla/Tabla";
import Loading from "../../Components/Loading/Loading";
import './desglose.css'

export default function Desglose() {

  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const [Comp, setComp] = useState({ Pagos: [], Loading:true })

  useEffect(() => {
    
    document.title = `Desgloce de Pagos KMP-${searchParams.get("id")}`;
    getDesgCotid(searchParams.get("id"), searchParams.get("hash")).then(res => {
      if (res.valid) {
        if (res.data.valid) {
          setComp(v => ({
            ...v,
            Loading:false,
            Pagos: res.data.payload.map((Pdata) => (
              {
                ...v.Pagos,
                idC: Pdata.idCotizacion,
                idP: Pdata.idMovimiento_Bancario,
                idPhash: Pdata.IdMovhash,
                width: '100%',
                height: "800px",
                Monto_Transferido: Pdata.Monto_Transferido,
                Monto_Perteneciente: Pdata.Monto_Perteneciente,
                Fact: Pdata.UUID,
                Facthash: Pdata.IdFacthash
              }
            ))
          }))
        } else {

        }
      } else {
        localStorage.removeItem("ContaKMPCot")
        navigate("/")
      }
    })
  }, [searchParams, navigate])


  return (
      <Navbar
        menu={[
          { txt: "Cotizaciones", link: "/FindCotizacion" },
          { txt: "Pagos", link: "/Pagos" }
        ]}>
      <Tabla className='DesgloseUser'>
        <Head>
          <Row className='Flags'>
            <Cell>Cotización</Cell>
            <Cell>Factura Relacionada</Cell>
            <Cell>Monto de la Transferencia</Cell>
            <Cell>Pago Perteneciente</Cell>
          </Row>
        </Head>
        <Body>
          {
            Comp.Loading === false ?
             Comp.Pagos.length > 0?
                         Comp.Pagos.map((Pa, iPa) =>
            (

              <Row key={iPa}>
                <Cell>KMP-{Pa.idC}</Cell>
                <Cell><Link to={`/FactView?hash=${Pa.Facthash}&uuid=${Pa.Fact}`} target="_blank" rel="noopener noreferrer">{Pa.Fact}</Link></Cell>
                <Cell><Link to={`/Pago?hash=${Pa.idPhash}&pay=${Pa.idP}`} target="_blank" rel="noopener noreferrer">
                  $ {new Intl.NumberFormat('en-US').format(Pa.Monto_Transferido)}
                </Link></Cell>
                <Cell>$ {new Intl.NumberFormat('en-US').format(Pa.Monto_Perteneciente)}</Cell>
              </Row>
            )):
             <Row>
              <Cell colSpan={4} style={{width:'100%'}}>
               No existen movimientos
              </Cell>
            </Row>
            :
            <Row>
              <Cell>
                <Loading style={{top:'80px'}}/>
              </Cell>
            </Row>
          }
        </Body>
      </Tabla>
    </Navbar>
  )
}
